import styled, { css } from "styled-components";

import { Paper } from "../Paper";

export const StyledHeader = styled(Paper)<{ size?: string }>`
  ${(props) =>
    props.size === "big" &&
    css`
      height: 140px;
    `}

  ${(props) =>
    props.size === "small" &&
    css`
      height: 4rem;
    `}

  padding: 0 1rem;
  display: flex;
  overflow: hidden;

  @media screen and (max-width: 350px) {
    overflow: auto;
  }
`;

StyledHeader.displayName = "StyledHeader";
